import React from "react";
import { TermsAndConditions } from "../../TermsAndConditions";

export const TermsAndConditionsInput = ({ register, errors }) => {
    return <div className="form-group label-no-margin-bs4">
        <div className="agreement clearfix l-h-24">
            <label className="mb-0 checkbox-container">
                <input
                    type="checkbox"
                    {...register("tos", { required: "You must accept the terms and conditions" })}
                />
                <span className="checkmark" style={{ top: '3px' }}></span>
                <TermsAndConditions hyperLinkColor="text-white" />
            </label>
            {errors.tos && <div className="upsell-input-error px-3 py-1">{errors.tos.message}</div>}
        </div>
    </div>;
};